// Automatic commercial follow-ups feed prospecting until explicitly scheduled.
export function isProspectingSuggestion(task) {
  const record = { ...(task.raw || {}), ...task, ...(task.commercialTask || {}) };
  task = record;
  const creator = task.taskCreator || task.createdBy || task.creatorId;
  const creatorName = typeof creator === "object" && creator
    ? creator.name || creator.username || [creator.firstname, creator.lastname].filter(Boolean).join(" ")
    : creator;
  const automatic = Boolean(task.automationKey || task.reactivationEngine) ||
    /^automatisme$/i.test(String(creatorName || "").trim());
  // Superseded automatic reminders belong to the client history, including
  // promised calls that have since been replaced by a newer conversation.
  const cancelled = task.cancelled || /annul|cancelled/i.test(String(task.status || ""));
  if (automatic && cancelled && /remplacé par le dernier appel|relance regroupée/i.test(String(task.cancelReason || ""))) return true;
  return automatic &&
    !task.promised && !task.engagementId &&
    !["appointment", "engagement", "manager", "invoice"].includes(task.category) &&
    !["promised-call", "appointment"].includes(task.automationKey) &&
    !task.plannedFromProspecting && !task.manuallyModified &&
    !task.manualEditedAt;
}
export function planProspectingTask(task, date) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) throw new Error("Choisissez une date valide.");
  return { ...task, due_date_original: date, scheduled_date: date, plannedFromProspecting: true, manuallyModified: true };
}
